<div class="page gray-font-color font-family bodyBackground">
  <div class="header-navigation-back">
    <mat-icon (click)="goBack()" data-test="back-arrow-icon" data-testid="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">On-Duty hours</span>
    <button
      mat-button
      [disabled]="!form.valid || loading"
      [class.save-disabled]="!form.valid || loading"
      class="header-action-button"
      (click)="onSubmit()"
      data-test="save-button"
      data-testid="save-button"
      >
      Save
    </button>
  </div>
  <div class="content">
    @if (loading) {
      <div>
        <div class="margin-left-sm margin-right-sm">
          <ngx-skeleton-loader count="6" appearance="line" [theme]="{ height: '30px' }"></ngx-skeleton-loader>
          <ngx-skeleton-loader appearance="line" [theme]="{ height: '120px' }"></ngx-skeleton-loader>
        </div>
      </div>
    } @else {
      <form [formGroup]="form" >
        <div  class="description-banner">
          <div class="description" data-testid="on-duty-description">
            <span>Please enter ON-DUTY hours for the last {{ workHourHistory.length }} days</span>
          </div>
        </div>
        <div  class="dates-container">
          @for (workHour of workHourHistory; track workHour; let i = $index) {
            <div  class="duty-date" [attr.data-testid]="'on-duty-day-' + i">
              <div  class="date-label" [attr.data-testid]="'on-duty-date-' + i">{{ workHour.date | date: 'dd MMM y' | uppercase }}</div>
              <div >
                <mat-form-field class="full-width" appearance="outline" data-test="hours-worked">
                  <mat-label> Hours worked </mat-label>
                  <mat-select [formControlName]="getFormControlName(i)" data-test="hours-work" [attr.data-testid]="'on-duty-hours-' + i">
                    @for (hour of hoursCombo; track hour) {
                      <mat-option [value]="hour" data-test="working-hours" [attr.data-testid]="'on-duty-hour-' + hour">
                        {{ hour }}</mat-option
                        >
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            }
          </div>
          <div  class="consent">
            <div >
              I hereby certify that the information given above is correct to the best of my knowledge and belief; and
              that I was last relieved from work at
            </div>
            <div  class="consent-date">
              <mat-form-field class="full-width text-grayed" appearance="outline">
                <input matInput autocomplete="off" formControlName="certifyCreatedAt" readonly />
                <mat-icon matSuffix svgIcon="calendar-line"></mat-icon>
              </mat-form-field>
            </div>
          </div>
        </form>
      }
    </div>
  </div>
